import { getLang } from "helpers/themeHelpers";
import { qsStringify } from "helpers/globalHelpers";
import { EnumIntegrationEvent } from "../../enums/EnumIntegrationEvent";
import { fetchVerticalAtClientSide } from "utils/misc/fetchClient";
import { isBrowser } from "utils/nookies/utils";
import { setCookie } from "utils/nookies";

export const linkToAddPost = () => {
  const lang = getLang();
  return process.env.NEXT_PUBLIC_ADD_POST_TEMPLATE_URL
      ? `${process.env.NEXT_PUBLIC_ADD_POST_TEMPLATE_URL}${
          `&return=` + (isBrowser() && window.location.href)
      }`.replace("{lang}", lang)
      : `/${lang}/post/create`;
};
export const addPostRef = () => {
  const referrer = isBrowser() && window.location.href;
  setCookie(null, "addPostRef", decodeURI(referrer));
  // Return the updated URL with the `referrer` query parameter
};

export const getIntegrationLink = (
    flow: EnumIntegrationEvent,
    postId?: string,
    showPhone?:boolean
) => {
  let qs = qsStringify({
    lang: getLang(),
    post_id: postId,
    flow,
    return: isBrowser() && `${window.location.href}${showPhone?"?showPhone="+showPhone:""}` ,
  });
  return `${
      flow == EnumIntegrationEvent.JOB_APPLY
          ? process.env.NEXT_PUBLIC_ADD_POST_TEMPLATE_URL + "?"
          : process.env.NEXT_PUBLIC_ADD_POST_TEMPLATE_URL
  }${qs ? qs.replace("?", "&") : ""}`;
};

export async function getCvScore() {
  const url = `jobs/v1/completion-score`;
  const data = await fetchVerticalAtClientSide<any>({ url });
  return data?.result?.data?.score;
}
